/**
 * Error tracking utility (console fallback; wire Sentry later if needed).
 */

const errorTracking = {
  initErrorTracking() {
    if (process.env.NODE_ENV === 'development') {
      console.log('Error tracking: console only');
    }
  },

  captureException(error, context = {}) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Error captured:', error, context);
    }
  },

  captureMessage(message, level = 'info', context = {}) {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[${level}] ${message}`, context);
    }
  },

  setUser() {},

  clearUser() {},
};

export const initErrorTracking = errorTracking.initErrorTracking;
export const captureException = errorTracking.captureException;
export const captureMessage = errorTracking.captureMessage;
export const setUser = errorTracking.setUser;
export const clearUser = errorTracking.clearUser;

export default errorTracking;


